import { Component, OnInit, OnDestroy } from "@angular/core";

import { Subscription } from "rxjs";
import { PainelComentariosParameters } from "src/app/models/PainelComentariosParameters";
import { PainelMarcacoesProvaParameters } from "src/app/models/PainelMarcacoesProvaParameters";
import { PlaceholderPaineisService } from "./placeholder-paineis.service";

@Component({
  selector: "app-placeholder-paineis",
  templateUrl: "./placeholder-paineis.component.html",
  styleUrls: ["./placeholder-paineis.component.scss"],
})
export class PlaceholderPaineisComponent implements OnInit, OnDestroy {
  public painelMarcacoesProvaParameters: PainelMarcacoesProvaParameters;
  public painelComentariosParameters: PainelComentariosParameters;
  public visible: boolean;
  private sPainelMarcacoesProvaParametersObservable: Subscription;
  private sPainelComentariosParametersObservable: Subscription;

  public constructor(
    private placeholderPaineisService: PlaceholderPaineisService
  ) {}

  public ngOnInit(): void {
    this.sPainelMarcacoesProvaParametersObservable =
      this.placeholderPaineisService
        .getPainelMarcacoesProvaParameters()
        .subscribe((params) => {
          this.painelMarcacoesProvaParameters = params;

          this.visible =
            this.painelMarcacoesProvaParameters !== null ||
            this.painelComentariosParameters !== null;
        });
    this.sPainelComentariosParametersObservable = this.placeholderPaineisService
      .getPainelComentariosParameters()
      .subscribe((params) => {
        this.painelComentariosParameters = params;

        this.visible =
          this.painelMarcacoesProvaParameters !== null ||
          this.painelComentariosParameters !== null;
      });
  }

  public ngOnDestroy(): void {
    this.sPainelComentariosParametersObservable.unsubscribe();
    this.sPainelMarcacoesProvaParametersObservable.unsubscribe();
  }

  public fecharPaineis(e: Event): void {
    if (
      ((<HTMLDivElement>e.target).parentNode &&
        (<HTMLDivElement>e.target).parentNode.nodeName ===
          "APP-PLACEHOLDER-PAINEIS") ||
      ((<HTMLDivElement>e.target).parentElement &&
        (<HTMLDivElement>e.target).parentElement.id === "placeholder-paineis")
    ) {
      this.placeholderPaineisService.fecharPainelMarcacoesProva();
      this.placeholderPaineisService.fecharPainelComentarios();
    }
  }
}
